<app-page-breadcrumb pageTitle="Miembros del equipo" />

<div class="space-y-6">
  @if (error) {
    <div class="rounded-xl border border-error-200 bg-error-50 p-4 dark:border-error-500/20 dark:bg-error-500/10">
      <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  }

  @if (team; as t) {
    <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
      <div class="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div class="flex flex-wrap items-center gap-2">
            <h2 class="text-xl font-semibold text-gray-800 dark:text-white">{{ t.name }}</h2>
            <span class="rounded-full px-2.5 py-0.5 text-[11px] font-semibold"
              [class.bg-success-50]="t.active" [class.text-success-700]="t.active"
              [class.dark:bg-success-500/10]="t.active" [class.dark:text-success-400]="t.active"
              [class.bg-gray-100]="!t.active" [class.text-gray-500]="!t.active"
              [class.dark:bg-gray-800]="!t.active" [class.dark:text-gray-400]="!t.active">
              {{ t.active ? 'Activo' : 'Inactivo' }}
            </span>
          </div>
          @if (t.description) {
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ t.description }}</p>
          }
          <p class="mt-1 text-xs text-gray-400">Idioma principal: {{ t.defaultLanguage || '—' }}</p>
        </div>
        <button type="button" (click)="agregar()"
          class="shrink-0 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600">
          + Agregar miembro
        </button>
      </div>
    </div>
  }

  <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
    @if (loading) {
      <p class="py-10 text-center text-sm text-gray-400">Cargando miembros…</p>
    } @else if (members.length === 0) {
      <div class="rounded-xl border border-dashed border-gray-300 py-12 text-center dark:border-gray-700">
        <p class="text-sm text-gray-500 dark:text-gray-400">Este equipo todavía no tiene miembros.</p>
        <p class="mx-auto mt-1 max-w-md text-xs text-gray-400">
          Sin miembros activos, el enrutamiento no puede asignarle conversaciones y aplicará la acción alternativa de la regla.
        </p>
        <button type="button" (click)="agregar()"
          class="mt-4 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600">
          Agregar el primer miembro
        </button>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="border-b border-gray-200 text-left text-xs text-gray-500 dark:border-gray-700 dark:text-gray-400">
              <th class="pb-2 pr-4 font-medium">Agente</th>
              <th class="pb-2 pr-4 font-medium">Peso</th>
              <th class="pb-2 pr-4 font-medium">Máx. simultáneos</th>
              <th class="pb-2 pr-4 font-medium">Idiomas</th>
              <th class="pb-2 pr-4 font-medium">Recibe</th>
              <th class="pb-2 pr-4 font-medium">Estado</th>
              <th class="pb-2 font-medium text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            @for (member of members; track member.id) {
              <tr class="border-b border-gray-100 last:border-0 dark:border-gray-800">
                <td class="py-3 pr-4">
                  <span class="font-medium text-gray-800 dark:text-gray-100">{{ member.userName }}</span>
                  @if (member.userEmail) {
                    <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{{ member.userEmail }}</p>
                  }
                </td>
                <td class="py-3 pr-4 text-gray-600 dark:text-gray-300">{{ member.routingWeight }}</td>
                <td class="py-3 pr-4 text-gray-600 dark:text-gray-300">{{ member.maxConcurrentChats }}</td>
                <td class="py-3 pr-4 text-gray-600 dark:text-gray-300">{{ idiomasResumen(member) }}</td>
                <td class="py-3 pr-4 text-gray-600 dark:text-gray-300">{{ canalesResumen(member) }}</td>
                <td class="py-3 pr-4">
                  <span class="rounded-full px-2.5 py-0.5 text-[11px] font-semibold"
                    [class.bg-success-50]="member.active" [class.text-success-700]="member.active"
                    [class.dark:bg-success-500/10]="member.active" [class.dark:text-success-400]="member.active"
                    [class.bg-gray-100]="!member.active" [class.text-gray-500]="!member.active"
                    [class.dark:bg-gray-800]="!member.active" [class.dark:text-gray-400]="!member.active">
                    {{ member.active ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
                <td class="py-3">
                  <div class="flex justify-end gap-2">
                    <button type="button" (click)="editar(member)"
                      class="rounded-lg bg-brand-50 px-3 py-1.5 text-xs font-medium text-brand-600 transition-colors hover:bg-brand-100 dark:bg-brand-500/10 dark:text-brand-400 dark:hover:bg-brand-500/20">
                      Editar
                    </button>
                    <button type="button" (click)="quitar(member)"
                      class="rounded-lg bg-error-50 px-3 py-1.5 text-xs font-medium text-error-700 transition-colors hover:bg-error-100 dark:bg-error-500/10 dark:text-error-400 dark:hover:bg-error-500/20">
                      Quitar
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <button type="button" (click)="volver()"
    class="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-brand-400">
    ← Volver a equipos de chat
  </button>
</div>
